import React, { Fragment } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter, Link } from "react-router-dom";
import styled from "styled-components";
import {Grid, Button} from "@material-ui/core";
import { Apps, Lock, AttachFile, InsertDriveFile, Repeat} from "@material-ui/icons";
import LoanStatuses, { CLOSED_LOAN } from 'constants/loanStatuses';
import dealStatuses from 'constants/dealStatuses';
import loanTypes from 'constants/loanTypes';
import loanSeniorities from 'constants/loanSeniorityTypes';
import { downloadDealQuotes } from "store/state/loan/loan";
import {getDealName, getDealPropertyProjections} from 'store/state/deal';
import {getFundName} from 'store/state/fund';
import BreadCrumbGrid from 'components/Global/BreadCrumb/BreadCrumbGrid';
import DealAttachments from 'components/Global/OptionsMenu/DealTable/DealAttachments';
import DealNotes from 'components/Global/OptionsMenu/DealTable/DealNotes';
import AddEditAlert from "components/Notifications/AddEditAlert";
import OptionsMenu from "components/Global/OptionsMenu/OptionsMenu";
import PrepaymentCalculatorModel from "./CalculatorDialogs/PrepaymentCalculatorModel"
import SimpleInfoDialog from 'components/Global/ConfirmationDialogs/SimpleInfoDialog';
import WhatIfModal from "components/Portfolio/WhatIfModal";
import LoanProceedsModal from "components/Calculators/LoanProceeds/ModalForm";
import SupplementalCalculatorModal from "./SupplementalCalculatorModal";
import DealPdfSummaryModal from '../Portfolio/DealPdfSummaryModal';

const LOANBOSS_BLUE = "#2196f3";

// const SectionTitle = styled.div`
//   font-size: 24px;
// `;
const NewButton = styled(Button)`
  && {
    margin-left: 4px;
    padding: 8px 8px 8px 2px;
    border-radius: 0;
    color: #2196f3;
    background: none;
  }
  & span {
    margin-left: 4px;
  }
  &&:hover {
    background: #f6f6f6;
  }
`;

const NewLockedButton =  styled(Button)`
&& {
  margin-left: 4px;
  padding: 8px 8px 8px 2px;
  border-radius: 0;
  color: #888888;
  background: none;
}
& span {
  margin-left: 4px;
}
&&:hover {
  background: #f6f6f6;
}
`;


const Container = styled.div`
  padding: 5px;
  border-width: 0px;
  height: 76px;
  background: inherit;
  background-color: rgba(255, 255, 255, 1);
  border: none;
  border-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
`;
const VerticalDivider = styled.div`
  height: 24px;
  border-right: 1px solid #cccccc;
`;
const StyledHeaderButton = styled(Button)`
  && {
    margin-left: 4px;
    padding: 8px 8px 8px 2px;
    border-radius: 0;
    color: #2196f3;
    background: none;
    position: unset;
  }
  &&:hover {
    background: none;
  }
`;

const NoteAttachementControlContainer = styled(Grid)`
  width:auto !important;
  float:right;
  min-width:250px;
  text-align:right;
`

const HeaderLeftContainer = styled(Grid)`
  max-width:calc(100% - 250px) !important;
`;

const AttachmentsButton = props => {
  return (
    <StyledHeaderButton variant="contained" onClick={props.onClick} disableRipple={true}>
      <AttachFile />
      ATTACHMENTS
    </StyledHeaderButton>
  );
};
const NotesButton = props => {
  return (
    <StyledHeaderButton variant="contained" onClick={props.onClick} disableRipple={true}>
      <InsertDriveFile />
      NOTES
    </StyledHeaderButton>
  );
};

const CalculatorButton = props => {
  return (
    <StyledHeaderButton variant="contained" onClick={props.onClick} disableRipple={true}>
      <Apps />
      ANALYSIS
    </StyledHeaderButton>
  );
};

class DealDetailsHeader extends React.Component {

  renderFeatureLockedModel = () => {
    return(
    <SimpleInfoDialog 
            title="Feature Locked"
            message="This feature is only available if you upgrade your account."
            modalOpen={this.state.popupOpen}
            handleClose={this.closePopup}
            handleAccept={this.closePopup}
            secondaryContent={
              <p>
                    If you would to schedule a demo to view these features, contact <a href ="mailto:sales@loanboss.com">sales@loanboss.com</a>. <br/> <br/>
                    Please contact your LoanBoss Administrator to upgrade or if you believe you are seeing this message in error: <a href="mailto:support@loanboss.com">support@loanboss.com</a>.
                  </p>
            }
            />
      )
  }
  


  state = {
    isNotesOpen: false,
    isAttachmentsOpen: false,
    fundId: 'free',
    isCapCalculatorOpen: false,
    isSwapCalculatorOpen: false,
    isPrepaymentCalculatorOpen: false,    
    popupOpen:false,
    isWhatIfModalOpen: false,
    isSupplementalCalculatorModalOpen: false,
    isLoanProceedsCalculatorOpen: false
  };
    getCalculatorOptions = () => {
      if(this.props.authentication.isGuest){
        if(!this.props.activeGuest.portfolioProjections){
          return [
            {
              id: 3,
              value: 'Prepayment',
              onClick: (optionId) => { this.setState({ isPrepaymentCalculatorOpen: true}) }
            },
          ]
        }
      }
      let out = [
        // TODO: uncomment once these stories are completed
        // {
        //   id: 1,
        //   value: 'Cap',
        //   onClick: (optionId) => { this.setState({ isCapCalculatorOpen: true}) }
        // },
        // {
        //   id: 2,
        //   value: 'Swap',
        //   onClick: (optionId) => { this.setState({ isSwapCalculatorOpen: true}) }
        // },
        {
          id: 3,
          value: 'Prepayment',
          onClick: (optionId) => { this.setState({ isPrepaymentCalculatorOpen: true}) }
        },
        {
          id: 4,
          value: 'Projections',
          onClick: (optionId) => { this.props.history.push(`/projections/${this.props.match.params.dealId}/false`)}
        },
        {
          id: 5,
          value: "What If (Beta)",
          onClick: this.openWhatIfModal,
        },
        {
          id: 6,
          value: "Loan Proceeds Calculator",
          onClick: this.openLoanProceedsCalculator,
        },
      ];
      if(this.hasFreddieLoan()){
        out.push({
          id: 7,
          value: "Supplemental Calculator",
          onClick: this.openSupplementalCalculator,
        });
      }
      return out;
    }

    hasFreddieLoan = () => {
      if(!this.props.loans) return false;
      let result = false;
      this.props.loans.forEach(x => {
        if(x.loanTypeId === loanTypes.FREDDIE_MAC && x.loanSeniorityId === loanSeniorities.SENIOR) {
          result = true;
        }
      })
      return result;
    }

    openSupplementalCalculator = () => {
      this.setState({
        isSupplementalCalculatorModalOpen: true,
      })
    }
  
    openLoanProceedsCalculator = () => {
      this.setState({
        isLoanProceedsCalculatorOpen: true,
      })
    }

    closeLoanProceedsCalculator = () => {
      this.setState({
        isLoanProceedsCalculatorOpen: false,
      })
    }
    
    openWhatIfModal = () => {
      this.setState({
        isWhatIfModalOpen: true,
      })
    }

    closeWhatIfModal = () => {
      this.setState({
        isWhatIfModalOpen: false,
      })
    }

  togglePdfSummaryModal = (isOpen) => this.setState({ isPdfSummaryModal: isOpen })

    componentDidMount = () => {      
      const {match} = this.props;
      const fundId = match.params.fundId;
      this.setState({
        dealId: match.params.dealId,
        fundId: fundId
      });
      this.props.getFundName({fundId: fundId, subKey: fundId});
      this.props.getDealPropertyProjections({dealId: match.params.dealId})
    }  

  renderFundLink =(deal) => {    
    const {fundId} = this.state;
    if(fundId === 'free')
      return null;
    if(!this.props.fundMap[fundId])
      return null;
    const fund = this.props.fundMap[fundId];
    return <Fragment><Link to={`/portfolio/funds/${fundId}`}>{fund.name}</Link> / </Fragment>;
  };
  openNotes = () => {
    this.setState({ isNotesOpen: true });
  };

  closeNotes = () => {
    this.setState({ isNotesOpen: false });
  };

  openAttachments = () => {
    this.setState({ isAttachmentsOpen: true });
  };

  closeAttachments = () => {
    this.setState({ isAttachmentsOpen: false });
  }; 
  buttonRenderer = (isMenuOpen, clickHandler) => {    
    return (
        <CalculatorButton onClick={clickHandler} disableRipple={true} />
    )
  }

  closeCalculator = () => {
    this.setState({
      ...this.state,
      isCapCalculatorOpen: false,
      isSwapCalculatorOpen: false,
      isPrepaymentCalculatorOpen: false,
      popupOpen:false,
    })
  }

  isProTier = () => {
    if(this.props.authentication){
      return this.props.authentication.companyLevel==="Professional"
      || this.props.authentication.companyLevel==="Enterprise"
      || this.props.authentication.companyLevel==="Secondary Sponsor"
  }else{
    return false;
  }
  }
  
  openPopup = () =>{
    this.setState({popupOpen: true});
  }

  closePopup = () =>{
    this.setState({popupOpen: false});
  }

  isEnabled = (guestPermissions) => {
    return ((!guestPermissions || (guestPermissions && !guestPermissions.isGuest)) && this.isProTier());
  }
  AddAlertButton = (dealId,action,guestPermissions) => {
    const isEnabled = this.isEnabled(guestPermissions);
    if(isEnabled){
      return (
        <Fragment>
          <NewButton onClick={action} disableRipple={true}>      
            ALERTS
          </NewButton>
        </Fragment>
      );
    }else{
      return (
        <Fragment>
          <NewLockedButton onClick={this.openPopup} disableRipple={true}>     
            <Lock/>
            ALERTS
          </NewLockedButton>
        </Fragment>
      );
    }
  };
   
  exportDealPDfButton = (dealId, action, guestPermissions) => {
    const isEnabled = this.isEnabled(guestPermissions);
    if (isEnabled) {
      return (
        <Fragment>
          <NewButton onClick={() => this.togglePdfSummaryModal(true)} disableRipple={true}>
            PDF SUMMARY
          </NewButton>
        </Fragment>
      );
    } else {
      return (
        <Fragment>
          <NewLockedButton onClick={() => this.togglePdfSummaryModal(true)} disableRipple={true}>
            <Lock />
            PDF SUMMARY
          </NewLockedButton>
        </Fragment>
      );
    }
  };
  
   SetReminderButton = (dealId,action,guestPermissions) => {
    const isEnabled = this.isEnabled(guestPermissions);
    if(isEnabled){
      return (
        <Fragment>
          <NewButton onClick={action} disableRipple={true}>      
            REMINDERS
          </NewButton>
        </Fragment>
      );
    }else{
      return (
        <Fragment>
          <NewLockedButton onClick={this.openPopup} disableRipple={true}>      
            <Lock />
            REMINDERS
          </NewLockedButton>
        </Fragment>
      );
    }
    
  };

  closeSupplementalCalculatorModal = () => {
    this.setState({
      isSupplementalCalculatorModalOpen: false,
    });
  }


  hasMultipleViews = () => {
    if(!this.props.deal) return null;
    let myStatus = this.props.deal.dealStatusId;
    return myStatus === dealStatuses.REFINANCE ||
            myStatus === dealStatuses.MODIFYING ||
            myStatus === dealStatuses.ADDING_SUPPLEMENTAL;
  }


  render(){
    const {dealId, downloadDealQuotes, deal, addEditAlertIsOpen,handleCancel,handleSave,isAlert, includeAlertButtons, addAlert, setReminder, guestPermissions} = this.props;
    const {
      isAttachmentsOpen,
      isNotesOpen,
    } = this.state;
    return (
      <Container>
        <AddEditAlert key={dealId}
            dealId={deal.id}
            notificationId={0}
            isOpen={addEditAlertIsOpen}
            handleCancel={handleCancel}
            handleSave={handleSave}                          
            isAlert={isAlert}
            isNew={true}/>
        <DealAttachments
            dealId={deal.id}
            isOpen={isAttachmentsOpen}
            openAttachments={this.openAttachments}
            closeAttachments={this.closeAttachments} />
        <DealNotes
            dealId={deal.id}
            isOpen={isNotesOpen}
            openNotes={this.openNotes}
            closeNotes={this.closeNotes} />
        <PrepaymentCalculatorModel
            dealId={deal.id} 
            isOpen={this.state.isPrepaymentCalculatorOpen}
            closeModal={this.closeCalculator}
        />
        
        {!this.props.authentication.isGuest &&
        (<Grid container direction="row" justify="flex-start" alignItems="center" spacing={16} >
          <Grid item>
            <BreadCrumbGrid>
              <Link to='/portfolio/'>Portfolio</Link> / {this.renderFundLink(deal)} {deal ? deal.name : '\u2014'}
              {this.hasMultipleViews() && <a href={`/pipeline/active/deals/${this.props.deal.id}`}><Repeat style={{color: LOANBOSS_BLUE, cursor: "pointer", marginBottom: '-5px', marginLeft: "10px" }}/></a>}
            </BreadCrumbGrid>
          </Grid>
        </Grid>)}
         <Grid container direction="row" justify="flex-start" alignItems="center" spacing={8}>
          <HeaderLeftContainer item xs={8}>
            <Grid container direction="row" justify="flex-start" alignItems="center" spacing={8}>
              <Grid item><div className="title-component">Deal Details</div></Grid>
              {includeAlertButtons && (
                <Fragment>
                  <Grid item>{this.AddAlertButton(dealId,addAlert,guestPermissions)}</Grid>
                  <Grid item><VerticalDivider /></Grid>
                  <Grid item>{this.SetReminderButton(dealId, setReminder, guestPermissions)}</Grid>
                  <Grid item><VerticalDivider /></Grid>
                  <Grid item>{this.exportDealPDfButton(dealId, null, guestPermissions)}</Grid>
                </Fragment>
                )}
            </Grid>
          </HeaderLeftContainer>
          <Grid item xs={4}>
            <NoteAttachementControlContainer container direction="row" justify="flex-start" alignItems="center" spacing={0}>
              <Grid item><OptionsMenu maxHeight={400}  buttonRenderer={this.buttonRenderer} options={this.getCalculatorOptions()}/></Grid>
              <Grid item><VerticalDivider /></Grid>
              <Grid item><NotesButton onClick={this.openNotes} disableRipple={true} /></Grid>
              <Grid item><VerticalDivider /></Grid>
              <Grid item><AttachmentsButton onClick={this.openAttachments} disableRipple={true} /></Grid>
            </NoteAttachementControlContainer>
          </Grid>
      </Grid>
    {this.renderFeatureLockedModel()}
    <DealPdfSummaryModal
      deal={deal}
      isOpen={this.state.isPdfSummaryModal}
      handleClose = {() => this.togglePdfSummaryModal(false)}
    />
    <WhatIfModal
      scope= "deal"
      dealId = {deal.id}
      isOpen = {this.state.isWhatIfModalOpen}
      handleClose = {this.closeWhatIfModal}
    />
    <LoanProceedsModal
      scope= "deal"
      dealId = {deal.id}
      isOpen = {this.state.isLoanProceedsCalculatorOpen}
      handleClose = {this.closeLoanProceedsCalculator}
    />
    <SupplementalCalculatorModal 
      deal = {deal}
      isOpen = {this.state.isSupplementalCalculatorModalOpen}
      handleClose = {this.closeSupplementalCalculatorModal}
      noiPrefill = {this.getNoiPrefillForSupplementalCalculator()}
      rateTypePrefill = {this.getRateTypePrefillForSupplementalCalculator()}
      loanToUse = {this.getLoanWithEarliestClose()}
      mostRecentSupplemental = {this.getMostRecentSupplementalLoan()}
    />
    </Container>
    );
  }

  getNoiPrefillForSupplementalCalculator = () => {
    let projections =  this.props.dealProjections[this.props.match.params.dealId];
    if(!projections) return null;
    projections = _.sortBy(projections, "periodDate");
    let projectionDate = null;
    let today = new Date();
    for(let i = 0; i < projections.length; i++) {
      let currentProjection = projections[i];
      projectionDate = new Date(currentProjection.periodDate);
      if(projectionDate && projectionDate > today) {
        return projections[i].noi;
      }
    }
    return null;
  }

  getRateTypePrefillForSupplementalCalculator = () => {
    if(!this.props.loans || this.props.loans.filter(x=>x.loanSeniorityId === loanSeniorities.SENIOR).length === 0) return null;
    let loanToUse = _.sortBy(this.props.loans.filter(x=>x.loanSeniorityId === loanSeniorities.SENIOR), "closingDate")[0];
    if(!loanToUse) {
      return null;
    };
    if(loanToUse.rateTypeRef) {
      return loanToUse.rateTypeRef.name.toUpperCase();
    } else {
      return null;
    }
  }

  getLoanWithEarliestClose = () => {
    if(!this.props.loans || this.props.loans.length === 0) return null;
    return _.sortBy(this.props.loans.filter(x=>x.loanSeniorityId === loanSeniorities.SENIOR), "closingDate")[0];
  }

  getMostRecentSupplementalLoan = () => {
    if(!this.props.loans || this.props.loans.length === 0) return null;
    return _.orderBy(this.props.loans.filter(x=>x.loanSeniorityId === loanSeniorities.SUPPLEMENTAL && !!x.closingDate), "closingDate", "desc")[0];
  }

};

const mapStateToProps = ({deal, fund, authentication, guest, loan}) => ({
  dealMap: deal.dealNames,
  fundMap: fund.fundNames,
  authentication,
  activeGuest: guest.activeGuest,
  loans : loan.loansByStatus[CLOSED_LOAN] ? loan.loansByStatus[CLOSED_LOAN].loans : [],
  dealProjections: deal.dealPropertyProjections
});

export default compose(
  withRouter,
  connect(
  mapStateToProps,  
  {
    getDealName,
    getFundName,
    downloadDealQuotes,
    getDealPropertyProjections,
  }
))(DealDetailsHeader);
